import { useTranslation } from "react-i18next";

import { CUSTOM_CONFIRM_TYPES, CustomConfirm } from "components";
import { useDeleteTyreDiscountMutation } from "modules/TyreDiscountsDashboard/components/DeleteTyreDiscountModal/hooks";

type DeleteTyreDiscountModalProps = {
  id: number;
  onResetDeleteTyreDiscountId: () => void;
};

export const DeleteTyreDiscountModal = ({ id, onResetDeleteTyreDiscountId }: DeleteTyreDiscountModalProps) => {
  const { t } = useTranslation();

  const { mutateAsync: deleteTyreDiscount, isPending } = useDeleteTyreDiscountMutation();

  const handleDeleteTyreDiscount = async () => {
    if (!id) return;
    await deleteTyreDiscount({ tyre_discount_id: id });
    onResetDeleteTyreDiscountId();
  };

  return (
    <CustomConfirm
      type={CUSTOM_CONFIRM_TYPES.Danger}
      isOpen={Boolean(id)}
      handleCancel={onResetDeleteTyreDiscountId}
      customTitle={t("v8_are_you_sure", "Are you sure?")}
      confirmMsg={t("v8_delete_confirm_message", "Are you sure that you want to delete this? You can't undo this action.")}
      handleConfirm={handleDeleteTyreDiscount}
      isLoading={isPending}
    />
  );
};
